import NotFoundDoorAndConfusedPenguinSvg from "./404-door-and-confused-penguin.svg";

export const NotFoundDoorAndConfusedPenguin = () => {
  return <NotFoundDoorAndConfusedPenguinSvg />;
};
